<div
  class="box-border relative grid items-start justify-center grid-flow-row gap-3 py-5 overflow-hidden px-9 bg-neutrals-100"
>
  <div class="flex items-center justify-between w-full">
    <!-- Close modal button -->
    <button
      class="grid items-center justify-start grid-flow-col gap-2"
      (click)="closeModal()"
    >
      <ui-icon name="chevron-left" fill="neutrals-600" m-size="24" size="24" />
      <ui-paragraph type="p14" mobile-type="p14" text-color="neutrals-600">
        Regresar
      </ui-paragraph>
    </button>

    <div class="grid items-center grid-flow-col gap-4">
      <unicon-user-chip
        *ngIf="dataLead.assignedAgent"
        [user]="
          dataLead.assignedAgent.firstName +
          ' ' +
          dataLead.assignedAgent.lastName
        "
      />
    </div>
  </div>

  <!-- Main Content -->
  <div class="grid grid-flow-col gap-5">
    <div
      class="flex flex-col justify-start h-[600px] max-h-[600px]"
      *ngIf="!loadingLead && lead; else informationLoading"
    >
      <unicon-identity-field
        [leadNames]="lead.leadNames"
        [leadFirstSurname]="lead.leadFirstSurname"
        [leadSecondSurname]="lead.leadSecondSurname"
        [leadStatusName]="lead.orderStatusName"
        [roleName]="lead.roleName"
        [isRecurring]="lead.isRecurring"
        [isPinned]="lead.isPinned"
        [hasHighClosingProbability]="lead.hasHighClosingProbability"
        class="w-[476px] min-w-[476px]"
        (result)="onSendFullName($any($event))"
        [isActivated]="isActivated"
        [user]="lead.assignedAgent"
        [orderId]="dataLead.orderId"
      />

      <div
        class="flex-grow p-6 bg-neutrals-100 border-neutrals-300 w-[476px] min-w-[476px] box-border round-bottom flex flex-col justify-start gap-4 overflow-y-auto"
      >
        <unicon-accordion-card title="Datos del cliente">
          <div class="flex flex-col gap-3 pt-3">
            <ui-headline
              type="h12"
              mobile-type="h12"
              font-weight="semibold"
              text-color="neutrals-900"
            >
              Información personal
            </ui-headline>
            <div class="flex flex-col gap-2">
              <unicon-document-field
                [documentType]="lead.leadIdentificationDocumentTypeId"
                [value]="lead.leadIdentificationDocumentNumber"
                [documentTypes]="documentTypes"
                (result)="onIdentificationNumber($any($event))"
                [isActivated]="isActivated"
              />
              <unicon-phone-field
                [value]="lead.leadPhone"
                (result)="onPhoneNumber($event)"
                [isActivated]="isActivated"
              />
              <unicon-email-field
                [value]="lead.leadEmail"
                (result)="onEmail($event)"
                [isActivated]="isActivated"
              />
            </div>
          </div>
          <div class="flex flex-col gap-3 pt-3">
            <div class="flex flex-col gap-2">
              <unicon-note-field
                [value]="lead.notes"
                title="Anotaciones"
                (result)="updateNote($event)"
                [loading]="loadingNote"
                [editNote$]="editNote$"
              />
            </div>
          </div>
        </unicon-accordion-card>

        <ng-container *ngIf="lead.shipping && lead.items; else emptyOrder">
          <unicon-accordion-card title="Detalle de la solicitud">
            <div class="flex flex-col gap-4 pt-3">
              <div class="flex flex-col gap-2">
                <ui-headline
                  type="h12"
                  mobile-type="h12"
                  font-weight="semibold"
                  text-color="neutrals-900"
                >
                  Producto o servicios
                </ui-headline>

                <unicon-order-item
                  [leadOrder]="lead.items"
                  (delete)="onDeleteProduct($event, lead.id)"
                  (edit)="onEditProduct($event, lead.id)"
                  (showAddItemButton)="onShowAddItemButton($event)"
                  [isActivated]="isActivated"
                />

                <unicon-product-field
                  *ngIf="add"
                  (result)="onAddProduct($event, lead.id)"
                  (cancel)="addItem()"
                  [verticalContainer]="true"
                />

                <unicon-action-button
                  *ngIf="hideAddButton && !add"
                  icon="tag"
                  text="Agregar un producto"
                  buttonStyle="add-item"
                  [disabled]="!isActivated"
                  (clicked)="addItem()"
                />
              </div>
              <div class="flex flex-col gap-2" *ngIf="businessLines.length > 0">
                <ui-headline
                  type="h12"
                  mobile-type="h12"
                  font-weight="semibold"
                  text-color="neutrals-900"
                >
                  Fecha requerida
                </ui-headline>

                <!-- Selectores de fecha por BusinessLine -->
                <div class="flex flex-col gap-3">
                  <ng-container *ngFor="let businessLine of businessLines">
                    <ng-container
                      *ngIf="
                        getItemsByBusinessLine(
                          businessLine.businessLineId
                        ) as items
                      "
                    >
                      <unicon-business-line-shipping-date
                        *ngIf="items.length > 0"
                        [businessLineId]="businessLine.businessLineId"
                        [businessLineName]="businessLine.businessLineName"
                        [orderId]="lead.id"
                        [currentStartDateTime]="items[0].shippingStartDateTime"
                        [currentEndDateTime]="items[0].shippingEndDateTime"
                        [readonly]="!lead.isActivated"
                        (openGrid)="onSetCalendarGrid($event, lead.id)"
                      />
                    </ng-container>
                  </ng-container>
                </div>

                <div class="p-1" *ngIf="errorCalendar">
                  <ui-alert
                    [message]="errorCalendar"
                    icon="warning-filled"
                    type="critical"
                    font-weight="semibold"
                    text-type="p12"
                    text-mobile-type="p12"
                  />
                </div>
              </div>

              <unicon-commercial-agreement-status
                [commercialAgreement]="lead.commercialAgreement"
              />
              <div class="flex flex-col gap-2">
                <ui-headline
                  type="h12"
                  mobile-type="h12"
                  font-weight="semibold"
                  text-color="neutrals-900"
                >
                  Ubicación de despacho
                </ui-headline>

                <unicon-location-field
                  [shipping]="lead.shipping"
                  (result)="onShippingResult(lead.id, $event)"
                  [isActivated]="isActivated"
                />
              </div>
              <div class="flex flex-col gap-2">
                <ui-headline
                  type="h12"
                  mobile-type="h12"
                  font-weight="semibold"
                  text-color="neutrals-900"
                >
                  Cotizaciones
                </ui-headline>
                <div
                  class="flex flex-col gap-1 box-border px-4 py-3 bg-neutrals-0 border-neutrals-300 rounded-[8px]"
                >
                  <div
                    class="flex items-center gap-4"
                    *ngFor="let quote of lead.quoteFiles"
                  >
                    <div class="flex items-center min-w-0 flex-1">
                      <ui-paragraph
                        class="truncate"
                        type="p12"
                        mobile-type="p12"
                        font-weight="regular"
                        text-color="neutrals-900"
                        [matTooltip]="quote.fileName"
                      >
                        {{ quote.fileName }}
                      </ui-paragraph>
                    </div>
                    <div class="flex items-center shrink-0">
                      <ui-paragraph
                        type="p12"
                        mobile-type="p12"
                        font-weight="regular"
                        text-color="neutrals-900"
                      >
                        {{ quote.createdDate | date: 'dd/MM/yy' }}
                      </ui-paragraph>
                    </div>
                    <div class="flex items-center shrink-0 whitespace-nowrap">
                      <ui-paragraph
                        type="p12"
                        mobile-type="p12"
                        font-weight="regular"
                        text-color="neutrals-900"
                      >
                        S/. {{ quote.totalAmount | number: '1.2-2' : 'en-US' }}
                      </ui-paragraph>
                    </div>
                    <div class="flex items-center shrink-0">
                      <button
                        class="bg-neutrals-200 p-2 rounded-[8px] hover:shadow-lg"
                        [matMenuTriggerFor]="quoteItemMenu"
                      >
                        <ui-icon
                          name="vertical-menu"
                          size="16"
                          m-size="16"
                          fill="neutrals-900"
                        />
                      </button>

                      <mat-menu #quoteItemMenu="matMenu" class="bg-white">
                        <div class="grid grid-flow-row w-[172px] box-border">
                          <button
                            mat-menu-item
                            class="flex flex-row items-center justify-start gap-2"
                            (click)="onDownloadQuote(quote.fileUrl)"
                            [disabled]="!isActivated"
                          >
                            <ui-icon
                              class="inline-flex flex-none mr-2"
                              name="download"
                              fill="neutrals-600"
                              size="16"
                              mSize="16"
                            />
                            <ui-paragraph
                              class="inline-flex flex-grow"
                              class="capitalize"
                              type="p12"
                              mobile-type="p12"
                              text-color="neutrals-900"
                              font-weight="regular"
                            >
                              Descargar
                            </ui-paragraph>
                          </button>
                        </div>
                      </mat-menu>
                    </div>
                  </div>
                </div>
                <unicon-action-button
                  icon="invoice"
                  text="Cotizar"
                  buttonStyle="action"
                  [disabled]="!isActivated"
                  (clicked)="onQuote(lead.id, 'unEdited')"
                />
                <unicon-action-button
                  *ngIf="lead.quoteFiles.length > 0"
                  icon="document"
                  text="Crear acuerdo venta"
                  buttonStyle="action"
                  [iconFill]="
                    isActivatedButton() ? 'neutrals-500' : 'neutrals-900'
                  "
                  [disabled]="isActivatedButton()"
                  (clicked)="onCommercialAgreement()"
                />
                <div class="p-1" *ngIf="showMessageEmpty">
                  <ui-alert
                    message="No cuenta con productos"
                    icon="warning-filled"
                    type="critical"
                    font-weight="semibold"
                    text-type="p12"
                    text-mobile-type="p12"
                  />
                </div>
              </div>
            </div>
          </unicon-accordion-card>
        </ng-container>

        <unicon-accordion-card title="Pedidos realizados">
          <div class="pt-3">
            <div
              class="box-border px-4 py-3 bg-neutrals-0 border-neutrals-300 rounded-[8px]"
            >
              <ui-paragraph
                type="p12"
                mobile-type="p12"
                font-weight="regular"
                text-color="neutrals-700"
              >
                Todavía no se ha realizado ningún pedido.
              </ui-paragraph>
            </div>
          </div>
        </unicon-accordion-card>
      </div>
    </div>

    <div
      class="flex flex-col w-[727px] max-w-[727px] h-[600px] max-h-[600px] relative"
      *ngIf="!loadingChat && chatList; else messagesLoading"
    >
      <unicon-topbar-field
        [lastSessionTime]="chatList.lastSentMessageDateTime || ''"
        class="flex-none"
        [leadId]="chatList.leadId"
        [orderId]="dataLead.orderId || ''"
        [dataLead]="dataLead"
        [leadCardList]="leadCardList || []"
        (nextOrder)="handleData($event)"
        [isActivated]="isActivated"
        [isBotMuted]="chatList.isBotMuted"
        (result)="onTopbarResult($event)"
      />

      <unicon-list-message-item
        class="flex-grow overflow-y-auto"
        [messages]="chatList.messages || []"
        [referral]="chatList.referral"
        (scrollUp)="onScrollUp()"
        (image)="onImage($event)"
        [pageNumber]="pageNumber"
        [lastPage]="chatList.lastPage"
        [isTabViewChat]="false"
      />

      <unicon-multimedia-field
        class="flex-none"
        [sellerName]="seller"
        [fullname]="dataLead.leadCompleteName"
        [isBlockedByAgent]="chatList.isBlockedByAgent"
        [isClosedLead]="chatList.isClosedLead"
        [leadId]="chatList.leadId"
        [isActivated]="isActivated"
        [agent]="
          dataLead.assignedAgent?.firstName +
          ' ' +
          dataLead.assignedAgent?.lastName
        "
        (message)="onSubmit($event)"
        [defaultQuickGroupId]="chatList.defaultQuickResponseGroupId"
      />

      <unicon-image-gallery
        *ngIf="selectedImage && !isFullScreen"
        (fullscreen)="fullscreen()"
        (close)="closeImageViewer()"
        [closeAll]="false"
        [selectedImage]="selectedImage"
      />
    </div>
  </div>

  <!-- Quote -->
  <div
    class="box-border absolute top-0 left-0 w-full h-full"
    *ngIf="showQuote && quote && orderId"
  >
    <unicon-quote-dialog
      class="quote-absolute-box"
      [orderId]="orderId"
      [quote]="quote"
      (close)="onCloseQuote()"
      (send)="onSend($event)"
      (onQuote)="onQuote($event)"
      [dataLead]="lead"
      [isLoadingQuote]="isLoadingQuote"
      [isLoadingSendQuote]="isLoadingSendQuote"
    />
  </div>

  <!-- Calendar Grid -->
  <div
    class="box-border absolute top-0 left-0 w-full h-full"
    *ngIf="showCalendarGrid"
  >
    <ng-container
      *ngFor="let key of [calendarGridKey]; trackBy: trackByGridKey"
    >
      <unicon-datetime-grid-dialog
        class="quote-absolute-box"
        [orderId]="calendarOrderId"
        [date]="dateCalendarGrid"
        [firstResult]="calendarGridResult"
        [businessLineId]="calendarGridBusinessLineId"
        (close)="onCloseCalendarGrid()"
        [lead]="lead"
      />
    </ng-container>
  </div>

  <unicon-image-gallery
    class="fixed top-0 left-0 right-0 bottom-0 w-[100vw] h-[100vh]"
    *ngIf="isFullScreen && selectedImage"
    [closeAll]="true"
    [selectedImage]="selectedImage"
    [fullSize]="true"
    (fullscreen)="fullscreen()"
    (close)="closeAllImageViewer()"
  />

  <ng-template #emptyOrder>
    <unicon-accordion-card title="Detalle de la solicitud">
      <div class="flex flex-col gap-4 pt-3">
        <div class="flex flex-col gap-2">
          <ui-headline
            type="h12"
            mobile-type="h12"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            Producto o servicios
          </ui-headline>
          <div
            class="box-border px-4 py-3 bg-neutrals-0 border-neutrals-300 rounded-[8px]"
          >
            <ui-paragraph
              type="p12"
              mobile-type="p12"
              font-weight="regular"
              text-color="neutrals-700"
            >
              Todavía no se ha agregado ningún producto.
            </ui-paragraph>
          </div>
          <unicon-action-button
            icon="tag"
            text="Agregar un producto"
            buttonStyle="add-item"
            [disabled]="!isActivated"
          />
        </div>
        <div class="flex flex-col gap-2">
          <ui-headline
            type="h12"
            mobile-type="h12"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            Fecha requerida
          </ui-headline>
          <unicon-text-field icon="clock" />
          <unicon-text-field icon="calendar" />
        </div>
        <div class="flex flex-col gap-2">
          <ui-headline
            type="h12"
            mobile-type="h12"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            Ubicación de despacho
          </ui-headline>
          <unicon-action-button
            icon="gps"
            text="Agregar ubicación"
            buttonStyle="add-item"
          />
        </div>
        <div class="flex flex-col gap-2">
          <ui-headline
            type="h12"
            mobile-type="h12"
            font-weight="semibold"
            text-color="neutrals-900"
          >
            Cotizaciones
          </ui-headline>
          <unicon-action-button
            icon="invoice"
            text="Cotizar"
            buttonStyle="action"
          />
        </div>
      </div>
    </unicon-accordion-card>
  </ng-template>

  <ng-template #informationLoading>
    <div class="flex flex-col justify-start">
      <div
        class="box-border flex items-center justify-between flex-none px-6 py-4 bg-neutrals-0 border-neutrals-300 round-top"
      >
        <div class="grid items-center grid-flow-col gap-8">
          <div class="grid items-center justify-center grid-flow-col gap-4">
            <ngx-skeleton-loader
              count="1"
              appearance="circle"
              [theme]="{ marginBottom: '0px', width: '36px', height: '36px' }"
            />
            <div class="flex flex-col justify-start w-[200px]">
              <ngx-skeleton-loader
                count="2"
                appearance="line"
                [theme]="{ marginBottom: '0px' }"
              />
            </div>
          </div>
        </div>
        <div class="w-[100px]">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ marginBottom: '0px' }"
          />
        </div>
      </div>

      <div
        class="flex-grow p-6 bg-neutrals-100 border-neutrals-300 w-[476px] min-w-[476px] box-border round-bottom flex flex-col justify-start gap-4 overflow-y-auto"
      >
        <unicon-accordion-card title="" *ngFor="let item of [0, 1]">
          <div class="flex flex-col gap-3 pt-3">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
            <div class="flex flex-col gap-2">
              <ngx-skeleton-loader
                count="3"
                appearance="line"
                [theme]="{ marginBottom: '0px' }"
              />
            </div>
          </div>
        </unicon-accordion-card>
      </div>
    </div>
  </ng-template>

  <ng-template #messagesLoading>
    <!-- Skeleton Loader for Chats -->
    <div class="flex flex-col w-[727px]">
      <div
        class="box-border flex items-center justify-between px-6 py-4 bg-neutrals-0 border-neutrals-300 round-top-alt"
      >
        <div class="grid grid-flow-row">
          <div class="grid items-center justify-start grid-flow-col gap-4">
            <div class="w-[24px]">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{ marginBottom: '0px' }"
              />
            </div>
            <div class="w-[200px]">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{ marginBottom: '0px' }"
              />
            </div>
          </div>
        </div>

        <div class="grid items-center grid-flow-col gap-6">
          <div class="w-[24px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
          <div class="w-[24px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
      </div>
      <div
        class="bg-neutrals-300 p-6 h-[432px] grid grid-flow-row gap-4 auto-rows-min overflow-y-auto"
      >
        <div class="grid justify-start grid-flow-row gap-1 client-message-box">
          <div class="chat-message-item px-3 py-2 box-border w-[280px]">
            <ngx-skeleton-loader
              count="3"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>

        <div class="grid justify-end grid-flow-row gap-1 adviser-message-box">
          <div class="chat-message-item px-3 py-2 box-border w-[280px]">
            <ngx-skeleton-loader
              count="3"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>

        <div class="grid justify-start grid-flow-row gap-1 client-message-box">
          <div class="chat-message-item px-3 py-2 box-border w-[280px]">
            <ngx-skeleton-loader
              count="2"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
      </div>
      <div
        class="box-border flex items-center justify-between p-6 bg-neutrals-0 border-neutrals-300 round-bottom"
      >
        <div
          class="flex flex-row gap-6 px-5 py-[10px] bg-neutrals-100 w-full box-border rounded-[12px] items-center"
        >
          <div class="flex-grow">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
          <button class="w-6">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #agreementLoading>
    <!-- Skeleton Loader for Chats -->
    <div class="flex flex-col w-[727px]">
      <div
        class="box-border flex items-center justify-between px-6 py-4 bg-neutrals-0 border-neutrals-300 round-top-alt"
      >
        <div class="grid grid-flow-row">
          <div class="grid items-center justify-start grid-flow-col gap-4">
            <div class="w-[24px]">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{ marginBottom: '0px' }"
              />
            </div>
            <div class="w-[200px]">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{ marginBottom: '0px' }"
              />
            </div>
          </div>
        </div>

        <div class="grid items-center grid-flow-col gap-6">
          <div class="w-[24px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
          <div class="w-[24px]">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
      </div>
      <div
        class="bg-neutrals-300 p-6 h-[432px] grid grid-flow-row gap-4 auto-rows-min overflow-y-auto"
      >
        <div class="grid justify-start grid-flow-row gap-1 client-message-box">
          <div class="chat-message-item px-3 py-2 box-border w-[280px]">
            <ngx-skeleton-loader
              count="3"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>

        <div class="grid justify-end grid-flow-row gap-1 adviser-message-box">
          <div class="chat-message-item px-3 py-2 box-border w-[280px]">
            <ngx-skeleton-loader
              count="3"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>

        <div class="grid justify-start grid-flow-row gap-1 client-message-box">
          <div class="chat-message-item px-3 py-2 box-border w-[280px]">
            <ngx-skeleton-loader
              count="2"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
        </div>
      </div>
      <div
        class="box-border flex items-center justify-between p-6 bg-neutrals-0 border-neutrals-300 round-bottom"
      >
        <div
          class="flex flex-row gap-6 px-5 py-[10px] bg-neutrals-100 w-full box-border rounded-[12px] items-center"
        >
          <div class="flex-grow">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </div>
          <button class="w-6">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{ marginBottom: '0px' }"
            />
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- Unarchive Alert -->
  <unicon-unarchive-alert
    [isVisible]="isNotificationVisible"
    [position]="'bottom'"
    (closeModalChat)="closeModalArchiveLead()"
    [closeModal]="closeModal"
    [orderId]="dataLead.orderId || ''"
    (onNextLead)="onNextLead($event)"
  ></unicon-unarchive-alert>
</div>
